/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateUpdateDeliverFeeInternationalReqVo,
  CreateUpdateDeliverFeeKrReqVo,
  ResponseDeliverFeeConfigInitRespVo,
  ResponseDeliveryCalculationInitRespVo,
  ResponseFreightCalculatorRespVo,
  ResponseGetDeliverFeeInternationRespVo,
  ResponseGetDeliverFeeKrRespVo,
  ResponseGetDeliverFeeOptionsVo,
  ResponseListDeliverFeeWarehouseTabRespVo,
  ResponseListGetDeliverFeeInternationalListRespVo,
  ResponseListGetDeliverFeeKrAmountlListRespVo,
  ResponseListGetDeliverFeeKrListRespVo,
  ResponseListGetOptionRespVo,
  ResponseString,
} from '../models/index';
import {
    CreateUpdateDeliverFeeInternationalReqVoFromJSON,
    CreateUpdateDeliverFeeInternationalReqVoToJSON,
    CreateUpdateDeliverFeeKrReqVoFromJSON,
    CreateUpdateDeliverFeeKrReqVoToJSON,
    ResponseDeliverFeeConfigInitRespVoFromJSON,
    ResponseDeliverFeeConfigInitRespVoToJSON,
    ResponseDeliveryCalculationInitRespVoFromJSON,
    ResponseDeliveryCalculationInitRespVoToJSON,
    ResponseFreightCalculatorRespVoFromJSON,
    ResponseFreightCalculatorRespVoToJSON,
    ResponseGetDeliverFeeInternationRespVoFromJSON,
    ResponseGetDeliverFeeInternationRespVoToJSON,
    ResponseGetDeliverFeeKrRespVoFromJSON,
    ResponseGetDeliverFeeKrRespVoToJSON,
    ResponseGetDeliverFeeOptionsVoFromJSON,
    ResponseGetDeliverFeeOptionsVoToJSON,
    ResponseListDeliverFeeWarehouseTabRespVoFromJSON,
    ResponseListDeliverFeeWarehouseTabRespVoToJSON,
    ResponseListGetDeliverFeeInternationalListRespVoFromJSON,
    ResponseListGetDeliverFeeInternationalListRespVoToJSON,
    ResponseListGetDeliverFeeKrAmountlListRespVoFromJSON,
    ResponseListGetDeliverFeeKrAmountlListRespVoToJSON,
    ResponseListGetDeliverFeeKrListRespVoFromJSON,
    ResponseListGetDeliverFeeKrListRespVoToJSON,
    ResponseListGetOptionRespVoFromJSON,
    ResponseListGetOptionRespVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface DeliverFeeInternationalListGetRequest {
    warehouseId: number;
    transportMethodId: number;
    orderTypeGroup: number;
}

export interface DeliverFeeInternationalOptionsGetRequest {
    warehouseId: number;
    transportMethodId: number;
    userId: number;
    orderType: number;
}

export interface DeliverFeeInternationalPostRequest {
    createUpdateDeliverFeeInternationalReqVo?: CreateUpdateDeliverFeeInternationalReqVo;
}

export interface DeliverFeeInternationalPutRequest {
    createUpdateDeliverFeeInternationalReqVo?: CreateUpdateDeliverFeeInternationalReqVo;
}

export interface DeliverFeeInternationalWarehouseIdTransportMethodIdDeleteRequest {
    warehouseId: number;
    transportMethodId: number;
    orderTypeGroup?: number;
}

export interface DeliverFeeInternationalWarehouseIdTransportMethodIdGetRequest {
    warehouseId: number;
    transportMethodId: number;
    orderTypeGroup?: number;
}

export interface DeliverFeeKrIdDeleteRequest {
    id: number;
}

export interface DeliverFeeKrIdGetRequest {
    id: number;
}

export interface DeliverFeeKrIdPutRequest {
    id: number;
    createUpdateDeliverFeeKrReqVo?: CreateUpdateDeliverFeeKrReqVo;
}

export interface DeliverFeeKrListGetRequest {
    warehouseId: number;
    transportMethodId: number;
    orderTypeGroup: number;
}

export interface DeliverFeeKrOptionsGetRequest {
    warehouseId: number;
    transportMethodId: number;
    userId: number;
    orderType: number;
}

export interface DeliverFeeKrPostRequest {
    createUpdateDeliverFeeKrReqVo?: CreateUpdateDeliverFeeKrReqVo;
}

export interface DeliverFeeWarehouseListGetRequest {
    orderTypeGroup?: number;
    nationId?: number;
    warehouseId?: number;
    transportMethodId?: number;
}

export interface DeliverFeeWarehouseOptionNationIdGetRequest {
    nationId?: number;
}

/**
 * 
 */
export class DeliverFeeStandardControllerApi extends runtime.BaseAPI {

    /**
     * 客户端·运费估算
     * 客户端·运费估算
     */
    async deliverFeeCalculationInitGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDeliveryCalculationInitRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/calculation/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDeliveryCalculationInitRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端·运费估算
     * 客户端·运费估算
     */
    async deliverFeeCalculationInitGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDeliveryCalculationInitRespVo> {
        const response = await this.deliverFeeCalculationInitGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 运费价格表·运费价格配置页面初始化
     * 运费价格表·运费价格配置页面初始化
     */
    async deliverFeeConfigInitGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDeliverFeeConfigInitRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/config/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDeliverFeeConfigInitRespVoFromJSON(jsonValue));
    }

    /**
     * 运费价格表·运费价格配置页面初始化
     * 运费价格表·运费价格配置页面初始化
     */
    async deliverFeeConfigInitGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDeliverFeeConfigInitRespVo> {
        const response = await this.deliverFeeConfigInitGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 运费计算器-基础运费数据（国际运费 + 韩国本土运费） 运费计算器-基础运费数据 返回全部国际运费和韩国本土运费信息列表，供运费计算器前端使用
     * 运费计算器-基础运费数据
     */
    async deliverFeeFreightCalculatorGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseFreightCalculatorRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/freight-calculator`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseFreightCalculatorRespVoFromJSON(jsonValue));
    }

    /**
     * 运费计算器-基础运费数据（国际运费 + 韩国本土运费） 运费计算器-基础运费数据 返回全部国际运费和韩国本土运费信息列表，供运费计算器前端使用
     * 运费计算器-基础运费数据
     */
    async deliverFeeFreightCalculatorGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseFreightCalculatorRespVo> {
        const response = await this.deliverFeeFreightCalculatorGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 指定仓库编号,运输方式编号,获取国际运费信息列表(query无分页) 根据用户等级分组 获取国际运费信息列表(query无分页)
     * 获取国际运费信息列表(query无分页)
     */
    async deliverFeeInternationalListGetRaw(requestParameters: DeliverFeeInternationalListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetDeliverFeeInternationalListRespVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeInternationalListGet().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeInternationalListGet().'
            );
        }

        if (requestParameters['orderTypeGroup'] == null) {
            throw new runtime.RequiredError(
                'orderTypeGroup',
                'Required parameter "orderTypeGroup" was null or undefined when calling deliverFeeInternationalListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        if (requestParameters['orderTypeGroup'] != null) {
            queryParameters['orderTypeGroup'] = requestParameters['orderTypeGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetDeliverFeeInternationalListRespVoFromJSON(jsonValue));
    }

    /**
     * 指定仓库编号,运输方式编号,获取国际运费信息列表(query无分页) 根据用户等级分组 获取国际运费信息列表(query无分页)
     * 获取国际运费信息列表(query无分页)
     */
    async deliverFeeInternationalListGet(requestParameters: DeliverFeeInternationalListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetDeliverFeeInternationalListRespVo> {
        const response = await this.deliverFeeInternationalListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取当前用户等级的（国际）运费步长规则 指定仓库编号,运输方式,用户id,获取(国际)运费步长规则(公式参数,前端本地展开)
     * 获取当前用户等级的（国际）运费步长规则
     */
    async deliverFeeInternationalOptionsGetRaw(requestParameters: DeliverFeeInternationalOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetDeliverFeeOptionsVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeInternationalOptionsGet().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeInternationalOptionsGet().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deliverFeeInternationalOptionsGet().'
            );
        }

        if (requestParameters['orderType'] == null) {
            throw new runtime.RequiredError(
                'orderType',
                'Required parameter "orderType" was null or undefined when calling deliverFeeInternationalOptionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetDeliverFeeOptionsVoFromJSON(jsonValue));
    }

    /**
     * 获取当前用户等级的（国际）运费步长规则 指定仓库编号,运输方式,用户id,获取(国际)运费步长规则(公式参数,前端本地展开)
     * 获取当前用户等级的（国际）运费步长规则
     */
    async deliverFeeInternationalOptionsGet(requestParameters: DeliverFeeInternationalOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetDeliverFeeOptionsVo> {
        const response = await this.deliverFeeInternationalOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 国际运费信息创建 国际运费信息创建
     * 国际运费信息创建
     */
    async deliverFeeInternationalPostRaw(requestParameters: DeliverFeeInternationalPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDeliverFeeInternationalReqVoToJSON(requestParameters['createUpdateDeliverFeeInternationalReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 国际运费信息创建 国际运费信息创建
     * 国际运费信息创建
     */
    async deliverFeeInternationalPost(requestParameters: DeliverFeeInternationalPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeInternationalPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 国际运费信息修改 国际运费信息修改
     * 国际运费信息修改
     */
    async deliverFeeInternationalPutRaw(requestParameters: DeliverFeeInternationalPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDeliverFeeInternationalReqVoToJSON(requestParameters['createUpdateDeliverFeeInternationalReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 国际运费信息修改 国际运费信息修改
     * 国际运费信息修改
     */
    async deliverFeeInternationalPut(requestParameters: DeliverFeeInternationalPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeInternationalPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 国际运费信息删除 国际运费信息删除
     * 国际运费信息删除
     */
    async deliverFeeInternationalWarehouseIdTransportMethodIdDeleteRaw(requestParameters: DeliverFeeInternationalWarehouseIdTransportMethodIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeInternationalWarehouseIdTransportMethodIdDelete().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeInternationalWarehouseIdTransportMethodIdDelete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderTypeGroup'] != null) {
            queryParameters['orderTypeGroup'] = requestParameters['orderTypeGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international/{warehouseId}/{transportMethodId}`.replace(`{${"warehouseId"}}`, encodeURIComponent(String(requestParameters['warehouseId']))).replace(`{${"transportMethodId"}}`, encodeURIComponent(String(requestParameters['transportMethodId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 国际运费信息删除 国际运费信息删除
     * 国际运费信息删除
     */
    async deliverFeeInternationalWarehouseIdTransportMethodIdDelete(requestParameters: DeliverFeeInternationalWarehouseIdTransportMethodIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeInternationalWarehouseIdTransportMethodIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,获取国际运费配置信息 运费价格表·国际运费修改详情接口
     * 运费价格表·国际运费修改详情接口
     */
    async deliverFeeInternationalWarehouseIdTransportMethodIdGetRaw(requestParameters: DeliverFeeInternationalWarehouseIdTransportMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetDeliverFeeInternationRespVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeInternationalWarehouseIdTransportMethodIdGet().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeInternationalWarehouseIdTransportMethodIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderTypeGroup'] != null) {
            queryParameters['orderTypeGroup'] = requestParameters['orderTypeGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/international/{warehouseId}/{transportMethodId}`.replace(`{${"warehouseId"}}`, encodeURIComponent(String(requestParameters['warehouseId']))).replace(`{${"transportMethodId"}}`, encodeURIComponent(String(requestParameters['transportMethodId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetDeliverFeeInternationRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,获取国际运费配置信息 运费价格表·国际运费修改详情接口
     * 运费价格表·国际运费修改详情接口
     */
    async deliverFeeInternationalWarehouseIdTransportMethodIdGet(requestParameters: DeliverFeeInternationalWarehouseIdTransportMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetDeliverFeeInternationRespVo> {
        const response = await this.deliverFeeInternationalWarehouseIdTransportMethodIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定国内运费价格信息编号,删除国内运费数据 指定国内运费价格信息编号,删除国内运费数据
     * 指定国内运费价格信息编号,删除国内运费数据
     */
    async deliverFeeKrIdDeleteRaw(requestParameters: DeliverFeeKrIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliverFeeKrIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 指定国内运费价格信息编号,删除国内运费数据 指定国内运费价格信息编号,删除国内运费数据
     * 指定国内运费价格信息编号,删除国内运费数据
     */
    async deliverFeeKrIdDelete(requestParameters: DeliverFeeKrIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeKrIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定国内运费价格信息编号,获取国内运费数据 指定国内运费价格信息编号,获取国内运费数据
     * 指定国内运费价格信息编号,获取国内运费数据
     */
    async deliverFeeKrIdGetRaw(requestParameters: DeliverFeeKrIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetDeliverFeeKrRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliverFeeKrIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetDeliverFeeKrRespVoFromJSON(jsonValue));
    }

    /**
     * 指定国内运费价格信息编号,获取国内运费数据 指定国内运费价格信息编号,获取国内运费数据
     * 指定国内运费价格信息编号,获取国内运费数据
     */
    async deliverFeeKrIdGet(requestParameters: DeliverFeeKrIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetDeliverFeeKrRespVo> {
        const response = await this.deliverFeeKrIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,修改国内运费信息 指定编号,修改国内运费信息
     * 指定编号,修改国内运费信息
     */
    async deliverFeeKrIdPutRaw(requestParameters: DeliverFeeKrIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deliverFeeKrIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDeliverFeeKrReqVoToJSON(requestParameters['createUpdateDeliverFeeKrReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 指定编号,修改国内运费信息 指定编号,修改国内运费信息
     * 指定编号,修改国内运费信息
     */
    async deliverFeeKrIdPut(requestParameters: DeliverFeeKrIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeKrIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 国内运费价格信息列表(query不分页) 国内运费价格信息列表(query不分页)
     * 国内运费价格信息列表(query不分页)
     */
    async deliverFeeKrListGetRaw(requestParameters: DeliverFeeKrListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetDeliverFeeKrListRespVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeKrListGet().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeKrListGet().'
            );
        }

        if (requestParameters['orderTypeGroup'] == null) {
            throw new runtime.RequiredError(
                'orderTypeGroup',
                'Required parameter "orderTypeGroup" was null or undefined when calling deliverFeeKrListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        if (requestParameters['orderTypeGroup'] != null) {
            queryParameters['orderTypeGroup'] = requestParameters['orderTypeGroup'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetDeliverFeeKrListRespVoFromJSON(jsonValue));
    }

    /**
     * 国内运费价格信息列表(query不分页) 国内运费价格信息列表(query不分页)
     * 国内运费价格信息列表(query不分页)
     */
    async deliverFeeKrListGet(requestParameters: DeliverFeeKrListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetDeliverFeeKrListRespVo> {
        const response = await this.deliverFeeKrListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取当前用户等级的（国内）运费列表 指定仓库编号,运输方式编号,用户id,获取(国内)运费信息options
     * 获取当前用户等级的（国内）运费列表
     */
    async deliverFeeKrOptionsGetRaw(requestParameters: DeliverFeeKrOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetDeliverFeeKrAmountlListRespVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling deliverFeeKrOptionsGet().'
            );
        }

        if (requestParameters['transportMethodId'] == null) {
            throw new runtime.RequiredError(
                'transportMethodId',
                'Required parameter "transportMethodId" was null or undefined when calling deliverFeeKrOptionsGet().'
            );
        }

        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling deliverFeeKrOptionsGet().'
            );
        }

        if (requestParameters['orderType'] == null) {
            throw new runtime.RequiredError(
                'orderType',
                'Required parameter "orderType" was null or undefined when calling deliverFeeKrOptionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetDeliverFeeKrAmountlListRespVoFromJSON(jsonValue));
    }

    /**
     * 获取当前用户等级的（国内）运费列表 指定仓库编号,运输方式编号,用户id,获取(国内)运费信息options
     * 获取当前用户等级的（国内）运费列表
     */
    async deliverFeeKrOptionsGet(requestParameters: DeliverFeeKrOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetDeliverFeeKrAmountlListRespVo> {
        const response = await this.deliverFeeKrOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 国内运费价格---- 国内运费价格信息创建
     * 国内运费价格信息创建
     */
    async deliverFeeKrPostRaw(requestParameters: DeliverFeeKrPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/kr`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateUpdateDeliverFeeKrReqVoToJSON(requestParameters['createUpdateDeliverFeeKrReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 国内运费价格---- 国内运费价格信息创建
     * 国内运费价格信息创建
     */
    async deliverFeeKrPost(requestParameters: DeliverFeeKrPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.deliverFeeKrPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·运费说明 国际运费+韩国国内运费统一平铺，按仓库/运输方式/分组分tab，feeType区分类型；重量/费用明细支持分页查看更多
     * 客户端·运费说明
     */
    async deliverFeeWarehouseListGetRaw(requestParameters: DeliverFeeWarehouseListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListDeliverFeeWarehouseTabRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['orderTypeGroup'] != null) {
            queryParameters['orderTypeGroup'] = requestParameters['orderTypeGroup'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['transportMethodId'] != null) {
            queryParameters['transportMethodId'] = requestParameters['transportMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/warehouse-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListDeliverFeeWarehouseTabRespVoFromJSON(jsonValue));
    }

    /**
     * 客户端·运费说明 国际运费+韩国国内运费统一平铺，按仓库/运输方式/分组分tab，feeType区分类型；重量/费用明细支持分页查看更多
     * 客户端·运费说明
     */
    async deliverFeeWarehouseListGet(requestParameters: DeliverFeeWarehouseListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListDeliverFeeWarehouseTabRespVo> {
        const response = await this.deliverFeeWarehouseListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取可用仓库列表(option) 获取可用仓库列表(option)
     * 获取可用仓库列表(option)
     */
    async deliverFeeWarehouseOptionNationIdGetRaw(requestParameters: DeliverFeeWarehouseOptionNationIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetOptionRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deliver-fee/warehouse/option/{nationId}`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 获取可用仓库列表(option) 获取可用仓库列表(option)
     * 获取可用仓库列表(option)
     */
    async deliverFeeWarehouseOptionNationIdGet(requestParameters: DeliverFeeWarehouseOptionNationIdGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetOptionRespVo> {
        const response = await this.deliverFeeWarehouseOptionNationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
